import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { takeUntil } from 'rxjs/operators' ;  import { Subject } from 'rxjs';
import { UserSessionService } from '../../shared';
import { ModalService } from '../../blocks';

@Component({
    selector: 'call-data-popup',
    templateUrl: './call-data-popup.component.html',
})

export class CallDataPopUpComponent implements OnInit, OnDestroy {
    private ngUnsubscribe: Subject<void> = new Subject<void>();
    callDataList = [];
 
    constructor(
        public translate: TranslateService,
        private _userSessionService: UserSessionService,
        private _modalService: ModalService
    ) { }

    ngOnInit() {
        this._userSessionService.subscribeToKey$('CallDataList')
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((keys: any) => {    
            if (keys.value) {
              this.callDataList = keys.value;
              console.log(this.callDataList)
            }

           

        });
      
    }

    ngOnDestroy() {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    }

 
}



